import React from 'react'
import { Brand, DevTools, Position, State } from 'src/types'
import DevTool from 'src/features/development'
// 捕球面の描画
import { Box } from '@mui/material'
import { dxmCanvasGloveFront } from 'src/features/brands/dxm/canvas/rightThrow/glove/front/useDxmCanvasGloveFront'
import { positionChecker } from 'src/util/useModelDesign'
import { ysrCanvasGloveFront } from 'src/features/brands/yellStory/canvas/glove/front/useYsrCanvasGloveFront'
import { ragdelionCanvasGloveFront } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/useRagdelionCanvasGloveFront'
import { gorillaCanvasGloveFront } from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/useGorillaCanvasGloveFront'
import { atomsCanvasGloveFront } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/useAtomsCanvasGloveFront'
import { atomsCanvasCatcherMittFront } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/front/useCanvasCatcherMittFront'
import { atomsCanvasFirstMittFront } from 'src/features/brands/atoms/canvas/rightThrow/firstmitt/front/useAtomsCanvasFirstMittFront'
import { ragdelionCanvasCatcherMittFront } from 'src/features/brands/ragdelion/canvas/catchermitt/rightThrow/front/useRagdelionCanvasCatcherMittFront'
import { ragdelionCanvasFirstMittFront } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/front/useRagdelionCanvasFirstMittFront'
import { gorillaCanvasFirstMittFront } from 'src/features/brands/gorilla/canvas/firstmitt/rightThrow/front/useGorillaCanvasFirstMittFront'
import { gorillaCanvasCatcherMittFront } from 'src/features/brands/gorilla/canvas/catchermitt/rightThrow/front/useGorillaCanvasCatcherMittFront'
import { atomsCanvasGloveFrontLeftThrow } from '../../atoms/canvas/leftThrow/glove/front/useAtomsCanvasGloveFront'
import { atomsCanvasFirstMittFrontLeftThrow } from '../../atoms/canvas/leftThrow/firstmitt/front/useAtomsCanvasFirstMittFront'
import { atomsCanvasCatcherMittFrontLeftThrow } from '../../atoms/canvas/leftThrow/catchermitt/front/useCanvasCatcherMittFront'
import { dxmCanvasGloveFrontLeftThrow } from '../../dxm/canvas/leftThrow/glove/front/useDxmCanvasGloveFront'
import { gorillaCanvasGloveFrontLeftThrow } from '../../gorilla/canvas/glove/leftThrow/front/useGorillaCanvasGloveFrontLeftThrow'
import { gorillaCanvasFirstMittFrontLeftThrow } from '../../gorilla/canvas/firstmitt/leftThrow/front/useGorillaCanvasFirstMittFront'
import { ragdelionCanvasGloveFrontLeftThrow } from '../../ragdelion/canvas/glove/leftThrow/front/useRagdelionCanvasGloveFront'
import { ragdelionCanvasFirstMittFrontLeftThrow } from '../../ragdelion/canvas/firstmitt/leftThrow/front/useRagdelionCanvasFirstMittFront'
import { ragdelionCanvasCatcherMittFrontLeftThrow } from '../../ragdelion/canvas/catchermitt/leftThrow/front/useRagdelionCanvasCatcherMittFront'
import { dxmCanvasCatcherMittFront } from '../../dxm/canvas/rightThrow/catcher/front/useCanvasCatcherMittFront'
import { dxmCanvasCatcherMittFrontLeftThrow } from '../../dxm/canvas/leftThrow/catcher/front/dxmCanvasCatcherMittFront'
import { dxmCanvasFirstMittFront } from '../../dxm/canvas/rightThrow/firstmitt/front/useAtomsCanvasFirstMittFront'
import { dxmCanvasFirstMittFrontLeftThrow } from '../../dxm/canvas/leftThrow/firstmitt/front/useDxmCanvasFirstMittFront'
import { usModelOfAtomsChecker } from '../../atoms/helper'
// import { treasureCanvasGloveFront } from 'src/features/brands/treasure/canvas/glove/front/useTreasureCanvasGloveFront'
// import { treasureCanvasCatcherMittFront } from 'src/features/brands/treasure/canvas/catchermitt/front/useTreasureCanvasCatcherMittFront'
// import { treasureCanvasFirstMittFront } from 'src/features/brands/treasure/canvas/firstmitt/front/useTreasureCanvasFirstMittFront'

type Props = {
  state: State
  position: Position
  brand: Brand
  devFlg?: boolean
  domId?: string
  devTools?: DevTools
  devToolStyle?: {
    backgroundImage: string
    backgroundRepeat: string
    backgroundPosition: string
    backgroundSize: string
    maxWidth: string
  }
  handleCoordinate?: (e: React.MouseEvent<HTMLCanvasElement, MouseEvent>) => void
}

export const FigureFront: React.FC<Props> = ({
  state,
  brand,
  position: beforeCheckPosition,
  devFlg,
  domId,
  devTools,
  devToolStyle,
  handleCoordinate
}) => {
  const position: Position = Array.isArray(beforeCheckPosition) ? beforeCheckPosition[0] : beforeCheckPosition // 2024/08/01くらいになったら削除
  const dominantArmValue = state.dominantArm.value
  const productNumber = state.baseModel?.productNumber
  React.useEffect(() => {
    const canvas = document.getElementById(domId || 'canvasFront') as HTMLCanvasElement
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
    ctx.strokeStyle = '#282828'
    ctx.lineWidth = 2
    const canvasWidth = canvas.width
    if (usModelOfAtomsChecker(productNumber)) {
      atomsCanvasGloveFront(ctx, state, position)
      return
    }
    switch (position) {
      case 'catcher':
        switch (brand) {
          case 'atoms':
            switch (state.dominantArm.value) {
              case 'leftThrow': // 左投げ
                atomsCanvasCatcherMittFrontLeftThrow(ctx, state, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                atomsCanvasCatcherMittFront(ctx, state)
                break
            }
            break
          case 'dxm':
            switch (state.dominantArm.value) {
              case 'leftThrow':
                dxmCanvasCatcherMittFrontLeftThrow(ctx, state, canvasWidth)
                break
              default:
                dxmCanvasCatcherMittFront(ctx, state)
                break
            }
            break
          case 'ragdelion':
            switch (state.dominantArm.value) {
              case 'leftThrow':
                ragdelionCanvasCatcherMittFrontLeftThrow(ctx, state, canvasWidth)
                break
              default:
                ragdelionCanvasCatcherMittFront(ctx, state)
                break
            }
            break
          // case 'treasure':
          //   treasureCanvasCatcherMittFront(ctx, state)
          //   break
          case 'gorilla':
            gorillaCanvasCatcherMittFront(ctx, state)
            break
        }
        break
      case 'first':
        switch (brand) {
          case 'atoms':
            switch (state.dominantArm.value) {
              case 'leftThrow': // 左投げ
                atomsCanvasFirstMittFrontLeftThrow(ctx, state, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                atomsCanvasFirstMittFront(ctx, state)
                break
            }
            break
          case 'ragdelion':
            switch (state.dominantArm.value) {
              case 'leftThrow':
                ragdelionCanvasFirstMittFrontLeftThrow(ctx, state, canvasWidth)
                break
              default:
                ragdelionCanvasFirstMittFront(ctx, state)
                break
            }
            break
          // case 'treasure':
          //   treasureCanvasFirstMittFront(ctx, state)
          //   break
          case 'gorilla':
            switch (state.dominantArm.value) {
              case 'leftThrow': // 左投げ
                gorillaCanvasFirstMittFrontLeftThrow(ctx, state, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                gorillaCanvasFirstMittFront(ctx, state)
                break
            }
            break
          case 'dxm':
            switch (state.dominantArm.value) {
              case 'leftThrow': // 左投げ
                dxmCanvasFirstMittFrontLeftThrow(ctx, state, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                dxmCanvasFirstMittFront(ctx, state)
                break
            }
            break
        }
        break
      default:
        switch (brand) {
          case 'atoms':
            switch (dominantArmValue) {
              case 'leftThrow': // 左投げ
                atomsCanvasGloveFrontLeftThrow(ctx, state, position, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                atomsCanvasGloveFront(ctx, state, position)
                break
            }
            break
          case 'yellStory':
            ysrCanvasGloveFront(ctx, state)
            break
          case 'dxm':
            switch (dominantArmValue) {
              case 'leftThrow': // 左投げ
                dxmCanvasGloveFrontLeftThrow(ctx, state, position, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                dxmCanvasGloveFront(ctx, state, position)
                break
            }
            break
          case 'ragdelion':
            switch (dominantArmValue) {
              case 'leftThrow': // 左投げ
                ragdelionCanvasGloveFrontLeftThrow(ctx, state, position, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                ragdelionCanvasGloveFront(ctx, state, position)
                break
            }
            break
          // case 'treasure':
          //   treasureCanvasGloveFront(ctx, state, position)
          //   break
          case 'gorilla':
            switch (dominantArmValue) {
              case 'leftThrow': // 左投げ
                gorillaCanvasGloveFrontLeftThrow(ctx, state, position, canvasWidth)
                break
              default:
                // 右投げ or 未選択
                gorillaCanvasGloveFront(ctx, state, position)
                break
            }
            break
        }
    }
  }, [state])
  const { isMitt } = positionChecker(position)
  return (
    <>
      {devFlg && handleCoordinate ? (
        <Box>
          <canvas
            width={880}
            height={isMitt ? 680 : 630}
            id={domId || 'canvasFront'}
            style={{ maxWidth: '100%', ...devToolStyle }}
            onClick={(e) => handleCoordinate(e)}
          />
          <DevTool devTools={devTools} />
        </Box>
      ) : (
        <canvas width={880} height={isMitt ? 680 : 630} id={domId || 'canvasFront'} style={{ maxWidth: '100%' }} />
      )}
    </>
  )
}
